import { APP } from 'src/Configs/App'
import { useAppSelector } from 'src/Hooks/redux'
import { rtkApi } from 'src/Services/rtkApi'
import { WiseCurrency } from 'src/Types/payments'
import { Roles } from 'src/Constants/enums'

import { getUserRole } from '../auth-process/credentialsSlice/selectors'

interface GetCurrenciesData {
  data: WiseCurrency[]
}
// 🥹
const wiseCurrenciesApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrencies: builder.query<GetCurrenciesData, void | null>({
      query: () => `${APP.TIKTOK_SERVER}/payout/transferwise/currencies`,
      providesTags: ['WiseCurrencies'],
    }),
    getCreatorCurrencies: builder.query<WiseCurrency[], void | null>({
      query: () => `${APP.TIKTOK_SERVER}/creator/payouts/wise/currencies`,
      providesTags: ['WiseCurrencies'],
    }),
    getCuratorCurrencies: builder.query<WiseCurrency[], void | null>({
      query: () => `${APP.TIKTOK_SERVER}/curator/payouts/wise/currencies`,
      providesTags: ['WiseCurrencies'],
    }),
  }),
})

export const {
  useGetCurrenciesQuery,
  useGetCreatorCurrenciesQuery,
  useGetCuratorCurrenciesQuery,
} = wiseCurrenciesApi

export const useCurrenciesQuery = (): WiseCurrency[] | undefined => {
  const role = useAppSelector(getUserRole)
  const isNewWise = APP.NEW_WISE_PROCESS_ENABLED

  const { data: currencies } = useGetCurrenciesQuery(null, {
    skip: isNewWise,
  })
  const { data: creatorCurrencies } = useGetCreatorCurrenciesQuery(null, {
    skip: !isNewWise || role !== Roles.influencer,
  })
  const { data: curatorCurrencies } = useGetCuratorCurrenciesQuery(null, {
    skip: !isNewWise || role !== Roles.curator,
  })

  return currencies?.data || creatorCurrencies || curatorCurrencies
}
